import React, { FC, useCallback } from 'react'
import { Button, Heading, Icon, Link, Modal, Text } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { Section75DisputeModalSteps, useSection75DisputeModalContext } from '../../Section75DisputeModalContext'
import { Trans, useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['dispute']

export interface ClaimEligibilityProps {
  openNormalDisputeModal?: () => void
}

export const ClaimEligibility: FC<ClaimEligibilityProps> = ({ openNormalDisputeModal }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { textSize } = useConsumerSizes()
  const { setStep, closeModal } = useSection75DisputeModalContext()

  const backHandler = useCallback(() => {
    closeModal()
  }, [closeModal])

  const startClaimHandler = useCallback(() => {
    setStep(Section75DisputeModalSteps.ChooseItems)
  }, [setStep])

  const handleFileNormalDispute = useCallback(() => {
    if (openNormalDisputeModal == null) {
      return
    }
    closeModal()
    openNormalDisputeModal()
  }, [closeModal, openNormalDisputeModal])

  return (
    <>
      <Modal.Header divider={true}>
        <div className='absolute z-10 pt-1'>
          <Button.Link size='Small' onClick={backHandler}>
            <Icon.CaretLeft size='Small' />
          </Button.Link>
        </div>
        <div className='text-center'>
          <Heading size='L'>{t('dispute:section75DisputeModal:claimEligibility:heading')}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div>
          <Text bold size={textSize}>
            {t('dispute:section75DisputeModal:claimEligibility:eligibleIf')}
          </Text>
          <ul>
            <li>
              <Text size={textSize}>{t('dispute:section75DisputeModal:claimEligibility:criteria')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('dispute:section75DisputeModal:claimEligibility:criteria2')}</Text>
            </li>
          </ul>
        </div>
        <div>
          <Text bold size={textSize}>
            {t('dispute:section75DisputeModal:claimEligibility:provideHeading')}
          </Text>
          <ul>
            <li>
              <Text size={textSize}>{t('dispute:section75DisputeModal:claimEligibility:provideBullet1')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('dispute:section75DisputeModal:claimEligibility:provideBullet2')}</Text>
            </li>
            <li>
              <Text size={textSize}>{t('dispute:section75DisputeModal:claimEligibility:provideBullet3')}</Text>
            </li>
          </ul>
        </div>
        <div>
          <Link>
            <Text bold underline size='S'>
              {t('dispute:section75DisputeModal:claimEligibility:learnMoreLinkText')}
            </Text>
          </Link>
        </div>
        <div className='mt-4'>
          <Text size={textSize}>
            <Trans
              i18nKey='dispute:section75DisputeModal:claimEligibility:disclaimer'
              components={{
                fileNormalDispute: <Link kind='Underline' onClick={handleFileNormalDispute} />,
              }}
            />
          </Text>
        </div>
        <div className='mt-4'>
          <Button padding='Fluid' size='Large' onClick={startClaimHandler}>
            {t('dispute:section75DisputeModal:claimEligibility:startClaim')}
          </Button>
        </div>
      </Modal.Content>
    </>
  )
}
